import React, { useEffect, useState } from "react";
import "../styles/Home.css";
import FeaturesAndProcess from "./features_process";
import BenefitsShowcase from "./BenefitsShowcase";
import TestimonialsFaqFooter from "./TestimonialsFaqFooter";
import NewsletterSignup from "./newsletter";
import { motion } from "framer-motion";   //  ⭐ ADD THIS
import { Link } from "react-router-dom";
import TrendingCompanies from "./TrendingCompanies";
import ChatWidget from "../components/ChatWidget";

function Home() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE = "https://api.niveshly.com";

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetch(`${API_BASE}/companies`);
        if (!response.ok) throw new Error("Failed to fetch companies");
        const data = await response.json();
        setCompanies(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanies();
  }, []);

  return (




    <div>

      {/* ---------- HERO SECTION ---------- */}
      <section className="hero-section">
        <svg className="spiral-left" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
          <path d="M 50 200 Q 100 100, 200 150 T 350 200" stroke="#e0e7ff" strokeWidth="2" fill="none" opacity="0.4" />
          <path d="M 30 250 Q 120 180, 220 200 T 370 250" stroke="#e0e7ff" strokeWidth="2" fill="none" opacity="0.3" />
        </svg>

        <svg className="spiral-right" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg">
          <path d="M 350 200 Q 300 100, 200 150 T 50 200" stroke="#ddd6fe" strokeWidth="2" fill="none" opacity="0.4" />
          <path d="M 370 250 Q 280 180, 180 200 T 30 250" stroke="#ddd6fe" strokeWidth="2" fill="none" opacity="0.3" />
        </svg>

        <motion.div
          className="tagline"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .6 }}
        >
          SECURE. EASY. EXCLUSIVE
        </motion.div>
        {/* 🔥 animate main headline */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .7, delay: .2 }}
        >
          Buy, Sell & Track <br /> Unlisted Shares Seamlessly
        </motion.h1>

        <p>
          Access private market investments, diversify your portfolio,
          <br />
          and grow your wealth with unlisted shares.
        </p>

        <div className="hero-buttons">
          <Link className="btn-outline" to="/explore">
            {/* 🔍 Explore Companies */}
            🚀 Start Investing
          </Link>
        </div>
        <section className="logo-ribbon">
          <div className="ribbon-track">
            {companies.concat(companies).map((c, i) => (
              <div className="ribbon-item" key={i}>
                <img src={c.logo} alt={c.name} />
              </div>
            ))}
          </div>

        </section>

      </section>
      <NewsletterSignup />

      {/* ---------- COMPANY LOGO RIBBON ---------- */}

      <TrendingCompanies />
      <div className="hero-buttons">
        <Link className="btn-outline" to="/explore">
          🔍 Explore Companies
          {/* 🚀 Start Investing */}
        </Link>
      </div>


      <FeaturesAndProcess />

      <BenefitsShowcase />



      <TestimonialsFaqFooter />

    </div>

  );
}

export default Home;